import { useMemo, useState } from 'react';

import { GridFilterModel } from '@mui/x-data-grid';
import { GridFilterItem } from '@mui/x-data-grid/models/gridFilterItem';
import { keyBy } from 'lodash';

import { AdminFacilityApiAdminFacilityPreProcessOnboardingGetRequest } from '@sbv-clients/data-access-api';

function assignIfDefined<T, K extends keyof T>(
  output: Partial<T>,
  key: K,
  value: any
) {
  if (value !== undefined) {
    output[key] = value;
  }
}

type FiltersType = Omit<
  AdminFacilityApiAdminFacilityPreProcessOnboardingGetRequest,
  'databaseName' | 'page' | 'pageSize'
>;

const transformInputToInterface = (input: GridFilterItem[]) => {
  const mapped = keyBy(input, 'field');
  const output: Partial<FiltersType> = {};
  assignIfDefined(output, 'firstName', mapped.firstName?.value);
  assignIfDefined(output, 'lastName', mapped.lastName?.value);
  assignIfDefined(output, 'employeeId', mapped.employeeId?.value);
  assignIfDefined(output, 'legacyLoginId', mapped.legacyLoginId?.value);
  assignIfDefined(
    output,
    'onboardingHealthStatus',
    mapped.onboardingHealthStatus?.value
  );
  assignIfDefined(output, 'role', mapped.role?.value);
  assignIfDefined(output, 'mobilePhone', mapped.mobilePhone?.value);

  return output as FiltersType;
};

export const useFiltersModel = () => {
  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: [],
  });
  const apiFilters = useMemo(
    () => transformInputToInterface(filterModel.items),
    [filterModel]
  );
  return {
    filterModel,
    setFilterModel,
    apiFilters,
  };
};
